import { render, staticRenderFns } from "./PanelViewButton.vue?vue&type=template&id=37770466&"
import script from "./PanelViewButton.vue?vue&type=script&lang=js&"
export * from "./PanelViewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports